import { Component, Input, OnInit, NgZone, inject, signal } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import moment from 'moment';
import { DailyOtsService } from './daily-ots.service';
import { Observable } from 'rxjs';
import { DailyOtCardComponent, DailyOtCardItem } from './daily-ot-card/daily-ot-card.component';
import { UserService } from 'src/app/shared/providers/auth/user.service';
import { UserProfil } from 'src/app/shared/providers/auth/user-profile.model';
import { Router } from '@angular/router';
import { VueJour } from 'src/app/shared/models/agenda/agenda-jour.model';
import { MenuService, MenuTitle } from 'src/app/shared/providers/menu.service';
import { NetworkProvider, NetworkStatus } from '../../../../shared/providers/network/network';
import { tap } from 'rxjs';

@Component({
  selector: 'daily-ots-widget',
  templateUrl: 'daily-ots-widget.component.html',
  styleUrls: ['daily-ots-widget.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule, DailyOtCardComponent],
})
export class DailyOtsWidgetComponent implements OnInit {
  @Input() resetSubject: Observable<boolean> = new Observable<boolean>();

  private userService = inject(UserService);
  private dailyOtsService = inject(DailyOtsService);
  private networkProvider: NetworkProvider = inject(NetworkProvider);
  private zone: NgZone = inject(NgZone);

  loading = signal<boolean>(false);
  otCardItems = signal<DailyOtCardItem[]>([]);
  isCurrentUserDiffu: boolean = false;
  NetworkStatusEnum = NetworkStatus;
  networkStatus: NetworkStatus = NetworkStatus.ONLINE;

  constructor(
    private router: Router,
    private menuService: MenuService
  ) {}

  async ngOnInit() {
    await this.refresh();
    //
    this.resetSubject.subscribe((response) => {
      if (response) {
        this.refresh();
      }
    });

    this.networkProvider.networkStatusSubject
      .pipe(
        tap((networkStatus) => {
          this.networkStatus = networkStatus;
          this.zone.run(() => {});
        })
      )
      .subscribe();
  }

  async refresh() {
    this.loading.set(true);
    const currentUser = this.userService.getCurrentUser();
    this.isCurrentUserDiffu = currentUser?.isDiffu();
    this.otCardItems.set(await this.dailyOtsService.getDailyOt(currentUser?.id));
    this.loading.set(false);
  }

  voirPlus() {
    const currentUser = this.userService.getCurrentUser();
    if (currentUser) {
      const isDiffus = currentUser.profils.some((role) => role === UserProfil.Diffus);
      if (isDiffus) {
        this.menuService.desactive(MenuTitle.AgendaEquipe);
        //
        const dateJour = moment();
        moment().toISOString();
        this.router.navigate(['/mnt/agenda/jour'], {
          queryParams: { page: VueJour.VueAgenda, dateJour, forceRefresh: true },
        });
      } else {
        this.menuService.desactive(MenuTitle.Tournee);
        this.router.navigate(['/mnt/round'], {
          queryParams: {
            forceRefresh: true,
          },
        });
      }
    }
  }
}
